module.exports = __webpack_public_path__ + "static/media/time-icon.1e471476.png";